import countriesAndStates from 'assets/countries_and_states.json'
import * as z from "zod";

export const createEcomFieldValidation = (key: string) => z
  .string()
  .min(1, { message: `Carbon Factor is required` })
  .refine((val) => !isNaN(Number(val)), {
    message: "Must be a number",
  })
  .refine((val) => Number(val) > 0, {
    message: `Carbon Factor must be greater than 0`,
  })
  .transform((val) => Number(val));

export const getRegionsForCountry = (countryName) => {
  const country = countriesAndStates.find(c => c.name === countryName);
  if (country?.states && country.states.length !== 0) {
    return country.states.map(s => s.name)
  } else return ["Non-Applicable"]
};